module.exports = __webpack_public_path__ + "img/0919_13.89555bd1.jpg";